import {BaseModuleProps} from "../../../../../infrastructure/models/props/base-module-props";
import {GameInfoModuleController} from "../game-info-module.controller";

export class GameInfoModuleProps extends BaseModuleProps {
  controller: GameInfoModuleController;
}
